import { gql } from "@apollo/client";
//this is for fetching business profile whole data
export const GET_BUSINESS_PROFILE = gql`
  query businessProfileData($id: String!) {
    businessProfileData(id: $id) {
      _id
      user_id
      name
      email
      phone
      logo
      location
      team
      description
      subscriptionName
      commission
    }
  }
`;

export const FETCH_BUSINESS_VERIFICATION_INFO = gql`
  query fetchBusinessVerification($business_id: String) {
    fetchBusinessVerification(business_id: $business_id) {
      legalBusinessName
      businessNumber
      taxNumber
      taxRate
      location
      rejectionReason
      termsAndConditions
      privacyPolicy
      verification
    }
  }
`;

export const HANDLE_BUSINESS_VERIFICATION_REQUEST = gql`
  mutation handleBusinessVerificationRequest(
    $verificationInfo: VerificationInfo
    $verificationType: String
  ) {
    handleBusinessVerificationRequest(
      verificationInfo: $verificationInfo
      verificationType: $verificationType
    ) {
      success
      message
      verificationStatus
    }
  }
`;

export const ADD_PICKUP_ADDRESS = gql`
  mutation addPickupAddress($businessId: String!, $address: InputAddress!) {
    addPickupAddress(businessId: $businessId, address: $address) {
      _id
      address
      lat
      lng
    }
  }
`;

export const EDIT_PICKUP_ADDRESS = gql`
  mutation editPickupAddress(
    $businessId: String!
    $address: InputAddress!
    $addressId: String!
  ) {
    editPickupAddress(
      businessId: $businessId
      address: $address
      addressId: $addressId
    ) {
      success
      message
      modifiedProducts
      updatedAddress {
        _id
        address
        lat
        lng
      }
    }
  }
`;

export const FETCH_PICKUP_ADDRESS = gql`
  query fetchPickupAddresses($businessId: String) {
    fetchPickupAddresses(businessId: $businessId) {
      _id
      address
      lat
      lng
    }
  }
`;

export const FETCH_COUNTRY_FOR_PICKUP = gql`
  mutation fetchCountryForPickup {
    fetchCountryForPickup
  }
`;

export const GET_BUSINESS_VERIFICATION_STATUS = gql`
  query getBusinessVerificationStatus($businessId: String!, $platform: String) {
    getBusinessVerificationStatus(businessId: $businessId, platform: $platform) {
      status
      canAcceptPayments
      chargesEnabled
      payoutsEnabled
      detailsSubmitted
      hasStripeErrors              
      stripeErrorMessages
      message
      actionRequired
      onboardingUrl
      dashboardUrl
    }
  }
`;

export const GET_BUSINESS_VERIFICATION_FULL_STATUS = gql`
  query getBusinessVerificationFullStatus($businessId: String!) {
    businessVerificationInfo(businessId: $businessId) {
      legalBusinessName
      businessNumber
      taxNumber
      taxRate
      location
      termsAndConditions
      privacyPolicy
      verification
      rejectionReason
    }
    stripeVerificationStatus(businessId: $businessId) {
      status
      canAcceptPayments
      chargesEnabled
      payoutsEnabled
      detailsSubmitted
      message
      actionRequired
      onboardingUrl
      dashboardUrl
    }
  }
`;
